import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import '../../../types/product.js';
import { isContactLens, isSolutions } from '../../../types/typeguards.js';
import { ProductDetailSpecification } from './ProductDetailSpecification.js';
import { getCategorySpecificationListItems } from './utils/get-category-specification-list-items.js';
import { getConfigurationSpecificationItems } from './utils/get-configuration-specification-items.js';
import { defaultCLFeatureSpecifications, defaultSolutionsFeatureSpecifications } from './utils/product-feature-defaults.js';

const ProductDetailSpecificationContainer = ({ className  })=>{
    const { getLabel  } = useIntl();
    const { product , activeVariant: { specifications  } , specificationConfiguration: opcoSpecificationConfig ,  } = useProductData();
    const { commercialCategories  } = product;
    const noOpcoSpecificationConfig = opcoSpecificationConfig.length === 0;
    let specificationConfig = opcoSpecificationConfig;
    if (noOpcoSpecificationConfig && isContactLens(product)) {
        specificationConfig = defaultCLFeatureSpecifications;
    } else if (noOpcoSpecificationConfig && isSolutions(product)) {
        specificationConfig = defaultSolutionsFeatureSpecifications;
    }
    const items = [
        ...getConfigurationSpecificationItems(specificationConfig, specifications, getLabel),
        ...getCategorySpecificationListItems(commercialCategories), 
    ];
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        className: className,
        items: items
    });
};

export { ProductDetailSpecificationContainer };
//# sourceMappingURL=ProductDetailSpecificationContainer.js.map
